<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" lg="6" sm="12">
        <v-card>
          <v-list-item>
            <v-list-item-avatar>
                <v-icon>mdi-playlist-edit</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="headline">工番情報編集</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-form ref="construction_number_form" v-model="valid" @submit.prevent>
              <v-text-field label="工番" v-model="construction_number" :rules="constructionNumberRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" class="mr-3" :to="{ name: 'ConstructionNumberFix' }" depressed>キャンセル</v-btn>
            <v-btn color="primary" @click.prevent="checkDialog" :disabled="!valid" depressed>確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleUpdate
        @updated="submit" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import statusList from "@/helpers/const";
  import ConstructionApi from "@/api/construction-api"
  import CustomDialog from "@/components/custom_ui/CustomDialog";
  import Rule from "@/validation/rules";

  export default {
    name: "ConstructionNumberFixEdit",
    components: {
      CustomDialog
    },
    data: () => ({
      loading: false,
      // フォームの項目
      construction_number: '',

      // 更新ダイアログ
      dialogMaxWith: 500,
      dialogTitle: '',
      dialogItems: [],
      dialogDrawer: false,
      editId: null,

      // バリデーション
      valid: true,
      constructionNumberRules: Rule.constructionNumberRules,
    }),
    created () {
      this.initialize();
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize () {
        this.isLoading();
        this.constructionApi = new ConstructionApi();
        this.editId = this.$route.params.id;
        const promise = this.constructionApi.info(this.editId);
        promise.then(response => {
            this.construction_number = response.data.body.construction_info.construction_number;
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else if (error.response.data.status == statusList.status.entityError) {
              this.$emit("error",error.response.data.message);
              this.$router.push({ name: "ConstructionNumberFix" })
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      },
      // 更新ボタン押下時イベント
      checkDialog () {
        this.dialogTitle = '更新しますか？';
        this.dialogItems = [
          { name: '工番', value: this.construction_number }
        ];
        this.dialogDrawer = true;
      },
      dialogCancel() {
        this.dialogDrawer = false;
      },
      submit() {
        if (this.$refs.construction_number_form.validate()) {
          this.isLoading();
          const params = {
            construction_number: this.construction_number
          };
          const promise = this.constructionApi.update(this.editId, params);
          promise.then((response) => {
              this.$router.push({ name: 'ConstructionNumberFix' });
              this.$emit('success', response.data.message);
          }).catch(error => {
            useAppInsights().trackException({exception: error});
            if(error.response){
              if(error.response.data.status == statusList.status.authError){
                this.dialogDrawer = false;
                this.$emit('logoutConform');
              } else {
                this.$emit("error",error.response.data.message);
              }
            }else{
              this.$emit("error","サーバーエラーが発生しました。");
            }
          }).finally(() => {
            this.isLoading();
          });
        }
      }
    }
  };
</script>

